/*
 * @Description  : 提供 url 解析的相关信息
 * @usage        :
 * @Date         : 2021-10-26 20:12:27
 * @Author       : hadeshe<hadeshe@tencent.com>
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-03-24 17:13:05
 * @FilePath: /vise/packages/app-share/src/composable/use-provide-url-info.ts
 */

import { provide, reactive } from 'vue';
import { useRoute, LocationQuery } from 'vue-router';

export const PROVIDED_URL_INFO_NAME = Symbol('urlInfo');

export type TUrlInfo = {
  query: LocationQuery & {
    id?: string;
    spid?: string;
    qua?: string;
    collectionid?: string,
    themeid?: string,
    scene?: string,
  }
};

export default function useProvideUrlInfo() {
  const route = useRoute();
  const info: TUrlInfo = reactive({
    query: (route?.query || {}),
  });

  const provideInfo = () => {
    provide(PROVIDED_URL_INFO_NAME, info);
  };

  return {
    info,
    provideInfo,
  };
}
